import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const restoreAddon = ({ _id }: { _id: string }): Promise<void> => {
  return axios.post(`/addons/${_id}/restore`);
};

type UseRestoreAddonOptions = {
  config?: MutationConfig<typeof restoreAddon>;
};

const TOAST_ID = 'restore-addon';

export const useRestoreAddon = ({ config = {} }: UseRestoreAddonOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['addons']);
      toasts.loadingToast.success(TOAST_ID, 'Add-on restored');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Restoring...');
      config.onMutate?.(...args);
    },
    mutationFn: restoreAddon,
  });
};
